import styled from 'styled-components';

export default styled.p`
    font-size: 15px;
    text-align: left;
    margin-bottom: 8px;
    color: rgba(46, 55, 62, 0.5);
`